import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { assetService } from "src/core/services/assetService";
import "./LandingBottom.css";

function LandingBottom() {
  const { t } = useTranslation();

  return (
    <div className="landingBottom ">
      <div className="grid container p-0">
        <div className="col-12 md:col-6 p-0 flex">
          <div className="side-div flex flex-column">
            <div className="side-div-child1"></div>
            <div className="side-div-child2"></div>
          </div>
          <div className="content-div-shared flex flex-column">
            <h2 className="title">{t("Home.PP.Title")}</h2>

            <span className="text">{t("Home.PP.Description")}</span>

            <Button
              className="next-button p-0 mt-1 mb-1 md:m-5 shadow-5"
              onClick={() => {
                window.open("https://paciensportal.hu/Patient", "_blank");
              }}
            >
              <div className="flex flex-column align-items-start gap-1">
                <div className="flex flex-row align-items-center gap-3">
                  <span className="font-semibold">
                    {t("Home.PP.Next").toUpperCase()}{" "}
                  </span>
                  <i className="pi pi-chevron-right"></i>
                </div>

                <span className="text-base">{t("Home.PP.NextSubTitle")}</span>
              </div>
            </Button>
          </div>
        </div>

        <div className="col-12 md:col-6 p-0">
          <img
            src={assetService.getImagePath("landing_bottom.png")}
            alt=""
            className="img block"
          />
        </div>
      </div>
    </div>
  );
}

export default LandingBottom;
